App.addModule(function(app) {
	
    if (!app.getConfigFlag('taboola/tracking/active') || !app.getConfig('taboola/tracking/account_id')) {
        return
    }

    app.onConsent('performance', () => {

        const taboolaId = app.getConfig('taboola/tracking/account_id'),
         currentProduct = app.get('current_product'),
                  order = app.get('checkout.order')
        
        app.loadScript('//cdn.taboola.com/libtrc/unip/'+ taboolaId +'/tfa.js')
	    
        window._tfa = window._tfa || []

        _tfa.push({id: taboolaId, notify: 'event', name: 'page_view'})
		
	    if (currentProduct) {
            _tfa.push({id: taboolaId, notify: 'ecevent', name: 'PRODUCT_VIEW', productIds: [currentProduct.sku]})
        }

        app.on('cart:update', (item, qty) => {
        	_tfa.push({id: taboolaId , notify: 'ecevent', name: 'ADD_TO_CART', productIds: [item.product.sku]})
        })

        if (order) {

            const items = []
            
            Object.values(order.items).forEach(item => {
                items.push({
            		productId: item.product.sku,
            		quantity: item.qty_ordered,
            		price: app.round(item.base_price, 2)
                })
            })

            _tfa.push({
                id: taboolaId,
                notify: 'ecevent',
                name: 'PURCHASE',
                orderId: order.increment_id,
                currency: order.base_currency_code,
                value: app.round(order.base_subtotal, 2),
                cartDetails: items
            })
        }
    })
})
